import { useEffect } from 'react'
import {
  CollectionReference,
  collection,
  onSnapshot,
  query,
} from 'firebase/firestore'
import Doctor from '../types/Doctor'
import useStore from '../store/useStore'
import { getEffectiveServices } from '../utils/firebaseServiceContext'

const useFetchDoctors = () => {
  const identityStatus = useStore((state) => state.identityStatus)
  useEffect(() => {
    if (!['primary', 'impersonating'].includes(identityStatus)) return
    return onSnapshot(
      query(
        collection(
          getEffectiveServices().firestore,
          'doctors',
        ) as CollectionReference<Doctor>
      ),
      (doctors) => {
        useStore.setState({ doctors })
      }
    )
  }, [identityStatus])
}

export default useFetchDoctors
